import { render, staticRenderFns } from "./MenuSelector.vue?vue&type=template&id=36dd9584"
import script from "./MenuSelector.vue?vue&type=script&lang=js"
export * from "./MenuSelector.vue?vue&type=script&lang=js"
import style0 from "./MenuSelector.vue?vue&type=style&index=0&id=36dd9584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports